export default __webpack_public_path__ + "static/media/KR.b966cb67.svg";